<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-1 p-pb-1">
      
      <div class="p-grid p-nogutter">
        <div class="p-col">
          <h2>
            {{$t('report.title')}}
          </h2>
        </div>
        <div v-if="role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY'" class="p-col-fixed p-pb-4" style="width: fit-content">
          <Button :label="$t('report.button_new_report')" @click="create()" icon="irinox-icon-button pi pi-plus" iconPos="left" />
        </div>
      </div>

        <div class="irinox-form report" >

          <div class="search-bar" style="float: right">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" :placeholder="$t('report.search')" :aria-label="$t('report.search')"/>
            <i class="pi pi-times" @click="function() {filters['global'].value=null}"/>
          </div>
          <div class="p-formgroup-inline p-ai-center">
            <div class="p-field">
              <Dropdown id="modelNumber" v-model="filters['modelNumber'].value" :options="modelNumbers" optionLabel="name" optionValue="code"
                :placeholder="$t('report.filter_model_ph')" />
            </div>
            <div class="p-field">
              <Dropdown id="status" v-model="filters['complete'].value" :options="statuses" optionLabel="name" optionValue="code"
                :placeholder="$t('report.filter_status_ph')" />
            </div>
          </div>

          <DataTable :value="reports" stripedRows sortField="updateTimestamp" :sortOrder="-1"
            v-model:filters="filters" responsiveLayout="stack" dataKey="installationReportId" 
            breakpoint="960px" >
            <template #empty>
                {{$t('report.empty_list')}}
            </template>
            <template #loading>
                {{$t('report.loading_list')}}
            </template>

            <Column field="installationReportId" :header="$t('report.col_id')" style="width: 80px"></Column>

            <Column field="updateTimestamp" :header="$t('report.col_date')" >
              <template #body="slotProps">
                <div>
                  <div v-if="is24hour">{{$d(new Date(slotProps.data.updateTimestamp * 1000),'long')}}</div>
                  <div v-else>{{$d(new Date(slotProps.data.updateTimestamp * 1000),'long12')}}</div>
                </div>
              </template>
            </Column>

            <Column field="serialNumber" :header="$t('report.col_serialnumber')" ></Column>

            <Column field="modelNumber" :header="$t('report.col_model')" >
              <template #body="slotProps">
                <div>
                  {{$functions.fixModelName(slotProps.data.modelNumber)}} 
                </div>
              </template>
            </Column>

            <Column field="company" :header="$t('report.col_company')" ></Column>

            <Column field="complete" :header="$t('report.col_status')"  style="width: 120px">
              <template #body="slotProps">
                <div>
                  {{ $t('report.status_'+slotProps.data.complete) }}
                </div>
              </template>
            </Column>

            <Column bodyClass="" class="irinox-table-buttons p-text-right"  style="width: 150px">
              <template #header>
                <span class="sr-only">{{$t('common.actions')}}</span>
              </template>
              <template #body="slotProps">
                <div class="button-body">

                  <img v-if="slotProps.data.complete" src="assets/irinox/icons/download.svg" @click="downloadDialog($event, slotProps.data.serialNumber, slotProps.data.installationReportId, slotProps.data.language)" 
                      v-tooltip.left="$t('report.tooltip_download')" :alt="$t('report.tooltip_download')"/>

                  <img v-if="(role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY') && slotProps.data.complete" class="disabled" src="assets/irinox/icons/info_edit.svg" :alt="$t('common.disabled')"/>
                  <img v-else-if="role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY'" src="assets/irinox/icons/info_edit.svg" @click="edit(slotProps.data.serialNumber, slotProps.data.installationReportId)" 
                      v-tooltip.left="$t('report.tooltip_edit')" :alt="$t('report.tooltip_edit')"/>

                  <i v-if="role.includes('INTERNAL') && slotProps.data.complete" class="pi pi-eye disabled" />
                  <i v-else-if="role.includes('INTERNAL')" class="pi pi-eye" @click="edit(slotProps.data.serialNumber, slotProps.data.installationReportId)" v-tooltip.left="$t('report.tooltip_view')" />
                </div>
              </template>
            </Column>

          </DataTable>

          <OverlayPanel ref="op" class="download-op" style="width: 200px">
            <div v-if="emptyLanguages" class="just-text">No report available</div>
            <div v-for="lang of languages" :key="'downloadreport_'+lang.code" @click="download($event, lang.code)" :style="{display: lang.display ? 'block' : 'none'}">{{lang.name}}</div>
          </OverlayPanel>

        </div>

    </div>
	</div>

  <!--        -->
  <!-- ERRORS -->
  <!--        -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('report.error_dialog')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('report.error_dialog')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />
  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('report.download_report_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

</template>

<script>
import ReportService from '../../service/ReportService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
// import IrinoxDialogLight from '../IrinoxDialogLight.vue';
import {FilterMatchMode} from 'primevue/api';
import { mapGetters } from 'vuex';

export default {
    components: {
          IrinoxDialogDark,
          // IrinoxDialogLight
    },
    data() {
        return {
          reports: [],
          filters: {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
              'modelNumber': {value: null, matchMode: FilterMatchMode.EQUALS},
              'complete': {value: null, matchMode: FilterMatchMode.EQUALS}
          },
          serialNumber: null,
          modelNumbers: [{ 
              code: null,
              name: this.$t('report.filter_remove') 
            }],
          statuses: [{ 
              code: null,
              name: this.$t('report.filter_remove') 
            },{ 
              code: false,
              name: this.$t('report.status_false') 
            },{ 
              code: true,
              name: this.$t('report.status_true') 
            }],
          dialog: {
            error: false,
            blockingError: false,
            success: false
          },
          languages: [{
                code: "en_GB",
                name: 'English',
                display: true,
              },{
                code: "it_IT",
                name: 'Italiano',
                display: true,
              },{
                code: "ru_RU",
                name: 'русский',
                display: false,
              },{
                code: "es_ES",
                name: 'Español',
                display: false,
              },{
                code: "nl_NL",
                name: 'Nederlands',
                display: false,
              },{
                code: "fr_FR",
                name: 'Français',
                display: false,
              },{
                code: "de_DE",
                name: 'Deutsche',
                display: false,
              },{
                code: "en_US",
                name: 'United States',
                display: false,
              },{
                code: "ja_JP",
                name: 'やまと',
                display: false,
              }],
          currentReport: {}
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          is24hour: 'userdata/is24hour',
          role: 'userdata/role',
        }),
        emptyLanguages: function() {
          for(let lang of this.languages) {
            if(lang.display) {
              return false;
            }
          }
          return true;
        }
    },
    watch: {
    },
    created() {
      this.reportService = new ReportService();
    },
    mounted() {
      this.reloadReports();
    },
    methods: {
      reloadReports() {
        this.reportService.getList(this.personaltoken)
          .then((data) => {
            if(data.code=='200') {
              this.reports = data.body;
              let mns = [];
              for(let i=0; i<this.reports.length; i++) {
                mns.push({ code: this.reports[i].modelNumber, name: this.$functions.fixModelName(this.reports[i].modelNumber) });
              }
              this.modelNumbers = this.$functions.uniqByKeepFirst(mns, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
              this.modelNumbers.unshift({ 
                code: null,
                name: this.$t('admin.appliances.filter_remove') 
              });
            } else {
              this.reports = [];
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            this.reports = [];
            console.error("ERROR "+error);
            this.dialog.error = true;
          });
      },
      downloadDialog(event, serialNumber, reportId, reportLanguage) {
        // if(!reportLanguage) {
        //   if(Math.random() < 0.5) {
        //     reportLanguage = ""
        //   } else {
        //     reportLanguage = "en_GB,it_IT"
        //   }
        // }
        this.currentReport.serialNumber = serialNumber;
        this.currentReport.reportId = reportId;
        for(let lang of this.languages) {
          lang.display = reportLanguage!=null && reportLanguage.includes(lang.code);
        }
        this.$refs.op.toggle(event);
      },
      download(event, lang) {
        this.$refs.op.toggle(event);
        this.reportService.download(this.personaltoken, this.currentReport.reportId, lang)
          .then((res) => {
            // let filename = "haccp_"+this.serialNumber+"_"+this.currentReport.timestamp+"."+type;
            // let contentDisposition = res.headers["content-disposition"];
            // if(contentDisposition) {
            //   filename = contentDisposition.replace(/.*filename="(.*)".*/g,"$1");
            // }
            this.dialog.success = true;
            let blob=new Blob([res.data], {type: "application/pdf"});
            let link=document.createElement('a');
            link.href=window.URL.createObjectURL(blob);
            link.download="report_"+this.currentReport.serialNumber+"_"+this.currentReport.reportId+"_"+lang+".pdf";
            link.click();
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      edit(serialNumber, reportId) {
        this.$router.push({ name: 'report-edit', params: { serialNumber: serialNumber, reportId: reportId } });
      },
      create() {
        this.$router.push({ name: 'report-new' });
      }
    }

}
</script>

<style scoped>

.irinox-form .p-dropdown {
  width: 200px;
}

.irinox-form .search-bar input {
  width: 100px;
}

.irinox-form .button-body img.disabled {
  opacity: 0.4;
  filter: alpha(opacity=40);
  -webkit-filter: grayscale(100%);
       -moz-filter: grayscale(100%);
         -o-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
            filter: grayscale(100%);
  cursor: unset;
}

.irinox-form i {
  font-size: 30px;
  cursor: pointer;
}
.irinox-form i.disabled {
  color: grey;
  cursor: unset;
}


</style>